var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrophy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7831_13223)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.3283 27.5602L17.5094 27.3161C17.4262 27.2911 17.3457 27.2918 17.2746 27.3139L11.9079 28.9993C11.9791 28.9773 12.0581 28.9768 12.1427 29.0016L12.9617 29.2457C13.0463 29.2704 13.1253 29.27 13.1965 29.2479L18.5631 27.5625C18.492 27.5845 18.4114 27.5853 18.3283 27.5602Z",
    fill: "white",
    stroke: "#9583FF",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.57122 14.4825L12.9379 12.7971L14.8952 13.3822L9.52854 15.0677L7.57122 14.4825Z",
    fill: "white",
    stroke: "#9583FF",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.52853 15.0681L14.896 13.3825L14.9141 16.0173L9.54513 17.7033L9.52853 15.0681Z",
    fill: "#9583FF",
    stroke: "#9583FF",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.52881 15.0678L9.54541 17.703L8.15782 17.2883C7.84235 17.1951 7.58488 16.7749 7.58263 16.3509L7.57122 14.4827L9.53029 15.0675L9.52881 15.0678Z",
    fill: "white",
    stroke: "#9583FF",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.87266 9.37923C7.67546 9.44171 7.54078 9.66757 7.54277 9.97813L7.57091 14.4814L12.9376 12.7959L12.9094 8.29267C12.9074 7.98211 13.0433 7.75444 13.2393 7.69377L7.87266 9.37923Z",
    fill: "#9583FF",
    stroke: "#9583FF",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5057 18.2874L11.5171 20.1556C11.5194 20.5796 11.2667 20.8472 10.9509 20.7526L10.1318 20.5085C9.81633 20.4153 9.55854 19.9937 9.55661 19.5711L9.54521 17.703L11.5043 18.2877L11.5057 18.2874Z",
    fill: "white",
    stroke: "#9583FF",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5054 18.2878L11.5168 20.1559C11.5188 20.4664 11.383 20.6941 11.1869 20.7548L16.5536 19.0693C16.7508 19.0068 16.8855 18.781 16.8835 18.4704L16.872 16.6023L11.5054 18.2878Z",
    fill: "#9583FF",
    stroke: "#9583FF",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.54515 17.7032L14.9133 16.0174L16.8721 16.6023L11.5054 18.2877L9.54515 17.7032Z",
    fill: "white",
    stroke: "#9583FF",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.2705 25.5096L19.4515 25.2655C19.3669 25.2408 19.2879 25.2412 19.2153 25.2636L13.8486 26.949C13.9198 26.927 14.0003 26.9262 14.0849 26.951L14.9038 27.195C14.9885 27.2198 15.0675 27.2193 15.1386 27.1973L20.5053 25.5118C20.4341 25.5339 20.3536 25.5347 20.2705 25.5096Z",
    fill: "white",
    stroke: "#9583FF",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2752 5.30665L11.4974 4.47774C11.4128 4.453 11.3338 4.45346 11.2626 4.47549L5.89598 6.16096C5.96713 6.13893 6.04765 6.13814 6.13078 6.16321L8.90853 6.99211C8.99166 7.01718 9.07218 7.0164 9.14333 6.99437L14.51 5.3089C14.4388 5.33093 14.3598 5.33139 14.2752 5.30665Z",
    fill: "white",
    stroke: "#9583FF",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.7291 29.3029L26.7226 28.2002L21.3551 29.8859L21.3616 30.9885C21.3638 31.4125 21.6225 31.8309 21.9368 31.9259L27.3043 30.2402C26.9888 30.1471 26.7313 29.7269 26.7291 29.3029Z",
    fill: "#9583FF",
    stroke: "#9583FF",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.1469 27.2643L25.3279 27.0202L19.9613 28.7057L20.7802 28.9498C21.0942 29.0433 21.3513 29.462 21.355 29.8857L26.7217 28.2002C26.7194 27.7762 26.4608 27.3578 26.1469 27.2643Z",
    fill: "white",
    stroke: "#9583FF",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.6927 23.4317C19.497 23.4938 19.3608 23.72 19.3628 24.0306L19.3861 27.7683C19.3883 28.1923 19.6458 28.6125 19.9612 28.7057L25.3279 27.0202C25.0124 26.927 24.7565 26.5065 24.7527 26.0828L24.7295 22.3451C24.7275 22.0345 24.8622 21.8087 25.0594 21.7462L19.6927 23.4317Z",
    fill: "#9583FF",
    stroke: "#9583FF",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.3308 33.1069L23.354 36.8447C23.3557 37.1538 23.2198 37.3814 23.0238 37.4421L28.3904 35.7566C28.5876 35.6941 28.7223 35.4683 28.7206 35.1592L28.6974 31.4215L23.3308 33.1069Z",
    fill: "#9583FF",
    stroke: "#9583FF",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.1223 30.484L27.3033 30.2399L21.9367 31.9254L22.7557 32.1695C23.0711 32.2627 23.3289 32.6843 23.3308 33.1069L28.6975 31.4214C28.6952 30.9974 28.4363 30.5775 28.1223 30.484Z",
    fill: "white",
    stroke: "#9583FF",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6345 21.3798C21.4373 21.4423 21.3026 21.6681 21.3046 21.9787L21.3123 23.0795C21.3143 23.39 21.1784 23.6177 20.9824 23.6784L26.349 21.9929C26.5448 21.9307 26.6809 21.7046 26.6789 21.394L26.6712 20.2932C26.6692 19.9827 26.8051 19.755 27.0011 19.6943L21.6345 21.3798Z",
    fill: "#9583FF",
    stroke: "#9583FF",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.5765 19.3293C23.3808 19.3914 23.2446 19.6176 23.2466 19.9282L23.2581 21.7963L28.6247 20.1108L28.6133 18.2427C28.6113 17.9321 28.746 17.7063 28.9432 17.6438L23.5765 19.3293Z",
    fill: "#9583FF",
    stroke: "#9583FF",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.2173 22.3813L25.2287 24.2494C25.231 24.6734 24.9782 24.9411 24.6624 24.8464L23.8434 24.6024C23.5279 24.5092 23.2719 24.0887 23.2682 23.665L23.2568 21.7968L25.2158 22.3816L25.2173 22.3813Z",
    fill: "white",
    stroke: "#9583FF",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.217 22.3815L25.2284 24.2496C25.2304 24.5602 25.0946 24.7879 24.8985 24.8485L30.2652 23.1631C30.4624 23.1006 30.5971 22.8747 30.5951 22.5642L30.5836 20.696L25.217 22.3815Z",
    fill: "#9583FF",
    stroke: "#9583FF",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.2597 21.796L28.6267 20.112L30.5837 20.6957L25.217 22.3811L23.2597 21.796Z",
    fill: "white",
    stroke: "#9583FF",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.1594 20.331L27.1708 22.1992C27.1731 22.6232 26.9215 22.889 26.606 22.7958L25.217 22.3814L25.2004 19.7462L27.1594 20.331Z",
    fill: "white",
    stroke: "#9583FF",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.2003 19.7462L30.5673 18.0622L32.526 18.647L27.1591 20.331L25.2003 19.7462Z",
    fill: "white",
    stroke: "#9583FF",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.1591 20.3312L27.1706 22.1993C27.1726 22.5099 27.0379 22.7358 26.8407 22.7982L32.2073 21.1128C32.4031 21.0506 32.5392 20.8244 32.5372 20.5139L32.5258 18.6458L27.1591 20.3312Z",
    fill: "#9583FF",
    stroke: "#9583FF",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.502 14.6444C25.3063 14.7065 25.1701 14.9327 25.1721 15.2433L25.2002 19.7465L30.5669 18.0611L30.5387 13.5578C30.5368 13.2472 30.6726 13.0196 30.8686 12.9589L25.502 14.6444Z",
    fill: "#9583FF",
    stroke: "#9583FF",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.5125 9.38828L30.5048 8.28748L25.1373 9.97314L25.145 11.0739C25.1472 11.498 25.4062 11.9178 25.7202 12.0113L31.0877 10.3257C30.7737 10.2321 30.5162 9.81197 30.5125 9.38828Z",
    fill: "#9583FF",
    stroke: "#9583FF",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.93 7.34827L15.3995 3.01046C15.3149 2.98572 15.2358 2.98618 15.1647 3.00821L9.79805 4.69367C9.8692 4.67164 9.94972 4.67085 10.0328 4.69592L24.5634 9.03373C24.8788 9.12691 25.1366 9.54858 25.1385 9.97111L30.5051 8.28564C30.5029 7.86163 30.244 7.44178 29.93 7.34827Z",
    fill: "white",
    stroke: "#9583FF",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.0727 13.7759L29.1141 20.1484C29.1161 20.459 28.9803 20.6867 28.7842 20.7473L34.1509 19.0619C34.3481 18.9994 34.4827 18.7735 34.4808 18.463L34.4394 12.0904L29.0727 13.7759Z",
    fill: "#9583FF",
    stroke: "#9583FF",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.8645 11.1548L31.0868 10.3259L25.7201 12.0113L28.4979 12.8402C28.8133 12.9334 29.0708 13.3536 29.073 13.7776L34.4397 12.0922C34.4374 11.6681 34.1788 11.2498 33.8645 11.1548Z",
    fill: "white",
    stroke: "#9583FF",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.5637 9.0344C24.8792 9.12759 25.1369 9.54926 25.1389 9.97178L25.1466 11.0726C25.1489 11.4966 25.4078 11.9164 25.7218 12.0099L28.4996 12.8389C28.8151 12.9321 29.0725 13.3523 29.0748 13.7763L29.1164 20.1487C29.1187 20.5727 28.866 20.8404 28.5502 20.7457L27.1613 20.3312L27.1331 15.828C27.1308 15.404 26.8733 14.9838 26.5579 14.8906L25.7389 14.6465C25.4249 14.553 25.1723 14.8206 25.1745 15.2446L25.2028 19.7478L23.8139 19.3333C23.4985 19.2401 23.2473 19.5074 23.2492 19.9299L23.2607 21.798L21.8718 21.3835C21.5564 21.2904 21.3034 21.5565 21.3057 21.9805L21.3134 23.0813C21.3157 23.5053 21.063 23.7729 20.7491 23.6794L19.9301 23.4353C19.6146 23.3421 19.3631 23.6079 19.3654 24.0319L19.3888 27.7696C19.391 28.1936 19.6485 28.6137 19.9639 28.7069L20.7829 28.951C21.0969 29.0446 21.354 29.4633 21.3578 29.8869L21.3644 30.9895C21.3667 31.4135 21.6253 31.8319 21.9395 31.9269L22.7585 32.171C23.074 32.2642 23.3318 32.6859 23.3337 33.1084L23.3571 36.8461C23.3605 37.2683 23.1064 37.5362 22.7906 37.4415L12.1771 34.2716C11.8616 34.1784 11.6057 33.7579 11.6022 33.3357L11.5789 29.598C11.5766 29.174 11.8293 28.9064 12.1432 28.9999L12.9622 29.244C13.2776 29.3372 13.5292 29.0714 13.5269 28.6474L13.5203 27.5448C13.518 27.1208 13.771 26.8547 14.0868 26.9494L14.9058 27.1935C15.2212 27.2867 15.4742 27.0205 15.4719 26.5965L15.4486 22.8588C15.4463 22.4348 15.1877 22.0165 14.8734 21.9215L14.0544 21.6774C13.739 21.5842 13.4812 21.1625 13.4792 20.74L13.4715 19.6392C13.4692 19.2152 13.2117 18.795 12.8963 18.7018L11.5074 18.2873L11.4959 16.4192C11.4925 15.997 11.235 15.5769 10.9207 15.4819L9.53179 15.0674L9.50352 10.5642C9.50124 10.1402 9.24378 9.71998 8.92835 9.62679L8.10935 9.38268C7.79391 9.28949 7.54092 9.55562 7.5432 9.97963L7.57148 14.4828L6.18256 14.0683C5.86713 13.9751 5.61115 13.5546 5.60739 13.131L5.5658 6.75851C5.56352 6.3345 5.81503 6.0687 6.13047 6.16189L8.90829 6.99087C9.22373 7.08406 9.47492 6.81677 9.47264 6.39277L9.4649 5.292C9.46262 4.86799 9.71528 4.60038 10.031 4.69505L24.5619 9.03325L24.5637 9.0344Z",
    fill: "white",
    stroke: "#9583FF",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7831_13223"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 40,
    height: 40,
    rx: 5,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrophy);
export default __webpack_public_path__ + "static/media/trophy.b50e95e9f010dc761016b206e310c1b6.svg";
export { ForwardRef as ReactComponent };